import React from "react";

export function Eyebrow({ children, num, className = "" }) {
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="section-eyebrow">
      {num && <span className="bjc-numeral">— {num}</span>}
      <span className="bjc-overline">{children}</span>
    </div>
  );
}

export function PageHero({ eyebrow, title, intro, num }) {
  return (
    <section className="relative pt-28 md:pt-36 pb-16 md:pb-24 border-b border-[var(--bjc-border)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-3">
          <Eyebrow num={num}>{eyebrow}</Eyebrow>
        </div>
        <div className="md:col-span-9">
          <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[var(--bjc-text)] tracking-tight">
            {title}
          </h1>
          {intro && (
            <p className="mt-8 text-base md:text-lg text-[var(--bjc-text-muted)] max-w-3xl leading-relaxed">
              {intro}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}

export default { Eyebrow, PageHero };
